import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Star, ChevronLeft, ChevronRight, Quote } from 'lucide-react';
import { testimonials } from '../mock/mock';

const Testimonials = () => {
  const [idx, setIdx] = useState(0);
  const t = testimonials[idx];
  const next = () => setIdx((idx + 1) % testimonials.length);
  const prev = () => setIdx((idx - 1 + testimonials.length) % testimonials.length);

  return (
    <section className="section-padding section-gradient-soft">
      <div className="container-x relative">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <div className="eyebrow-light mb-4"><span className="w-1.5 h-1.5 rounded-full bg-sky-500" /> Client Voices</div>
          <h2 className="section-title-dark">What Our <span className="gradient-text">Clients Say</span></h2>
        </div>

        <div className="relative max-w-4xl mx-auto">
          <AnimatePresence mode="wait">
            <motion.div
              key={t.id}
              initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.5 }}
              className="relative glass-light-card rounded-3xl p-8 md:p-12 shadow-2xl"
            >
              <Quote className="absolute top-6 right-6 text-sky-200" size={80} />
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: 5 }).map((_, i) => (
                  <Star key={i} size={18} className={i < Math.round(t.rating) ? 'text-yellow-400 fill-yellow-400' : 'text-slate-200 fill-slate-200'} />
                ))}
                <span className="ml-2 text-sm text-slate-500">{t.rating.toFixed(1)}</span>
              </div>
              <p className="text-lg md:text-xl text-slate-700 leading-relaxed italic">“{t.quote}”</p>
              <div className="mt-8 flex items-center gap-4">
                <div className="w-14 h-14 rounded-full overflow-hidden ring-2 ring-sky-400 ring-offset-2 shadow-lg">
                  <img src={t.image} alt={t.name} className="w-full h-full object-cover" />
                </div>
                <div>
                  <div className="font-bold text-slate-900">{t.name}</div>
                  <div className="text-sm text-slate-500">{t.role}</div>
                </div>
              </div>
            </motion.div>
          </AnimatePresence>

          <div className="flex justify-center items-center gap-4 mt-8">
            <button onClick={prev} className="w-11 h-11 rounded-full bg-white border border-sky-200 hover:border-sky-500 hover:text-sky-600 text-slate-600 flex items-center justify-center transition-all shadow-sm">
              <ChevronLeft size={20} />
            </button>
            <div className="flex gap-2">
              {testimonials.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setIdx(i)}
                  className={`h-2 rounded-full transition-all ${i === idx ? 'w-8 bg-gradient-to-r from-sky-500 to-blue-500' : 'w-2 bg-sky-200'}`}
                />
              ))}
            </div>
            <button onClick={next} className="w-11 h-11 rounded-full bg-white border border-sky-200 hover:border-sky-500 hover:text-sky-600 text-slate-600 flex items-center justify-center transition-all shadow-sm">
              <ChevronRight size={20} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
